// Module
var code = "<h1>Your zenflow accounts</h1> <div class=\"block\"> <div id=\"userAccounts\"> <progress class=\"progress is-small is-info\" max=\"100\">Loading</progress> </div> </div> <div class=\"block\"> <div id=\"formCreateAccount\"></div> </div> ";
// Exports
export default code;